import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { KindredTamaguiProvider, TamaguiFoundationProbe, kindredTamaguiConfig } from "../ui-foundation";
import { initWebSentry } from "@/lib/sentry";

initWebSentry();

if (typeof document !== "undefined" && !document.getElementById("kindred-tamagui-css")) {
  const tamaguiStyleTag = document.createElement("style");
  tamaguiStyleTag.id = "kindred-tamagui-css";
  tamaguiStyleTag.textContent = kindredTamaguiConfig.getCSS();
  document.head.appendChild(tamaguiStyleTag);
}

createRoot(document.getElementById("root")!).render(
  <KindredTamaguiProvider>
    <App />
    {import.meta.env.DEV ? <TamaguiFoundationProbe /> : null}
  </KindredTamaguiProvider>,
);
